import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReusableForm from '../../components/ReusableForm';
import { resetearContrasena } from '../../services/Auth/forgotPasswordServer';
import '../styles/FormPageStyles.css';

const ResetPasswordPage = () => {
  const [nuevaContrasena, setNuevaContrasena] = useState('');
  const [confirmarContrasena, setConfirmarContrasena] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [token, setToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem('token_temporal');
    if (!storedToken) {
      setError('Token no encontrado o expirado. Por favor, solicita un nuevo código de verificación.');
      // Opcionalmente, redirigir si no hay token
      // setTimeout(() => navigate('/forgot-password'), 3000);
    } else {
      setToken(storedToken);
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!nuevaContrasena || !confirmarContrasena) {
      setError('Por favor, completa ambos campos de contraseña.');
      return;
    }

    if (nuevaContrasena !== confirmarContrasena) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    if (!token) {
      setError('Error de autorización. No se encontró el token necesario.');
      return;
    }

    try {
      const result = await resetearContrasena(token, nuevaContrasena);
      if (result.success) {
        setSuccessMessage(result.message || 'Contraseña actualizada exitosamente. Redirigiendo al login...');
        localStorage.removeItem('token_temporal'); // Eliminar token después de usarlo
        setTimeout(() => {
          navigate('/auth/login');
        }, 3000);
      } else {
        setError(result.message || 'Error al actualizar la contraseña.');
      }
    } catch (err) {
      console.error("Error al resetear contraseña:", err);
      setError(err.message || 'Ocurrió un error al intentar actualizar la contraseña.');
    }
  };

  return (
    <ReusableForm
      title="Establecer Nueva Contraseña"
      error={error}
      successMessage={successMessage}
      handleSubmit={handleSubmit}
      submitButtonText="Actualizar Contraseña"
    >
      <div className="form-group">
        <input
          type="password"
          id="nuevaContrasena"
          value={nuevaContrasena}
          onChange={(e) => setNuevaContrasena(e.target.value)}
          required
          className="form-input"
          placeholder="Introduce tu nueva contraseña"
        />
      </div>
      <div className="form-group">
        <input
          type="password"
          id="confirmarContrasena"
          value={confirmarContrasena}
          onChange={(e) => setConfirmarContrasena(e.target.value)}
          required
          className="form-input"
          placeholder="Confirma tu nueva contraseña"
        />
      </div>
    </ReusableForm>
  );
};

export default ResetPasswordPage;
